import { render } from "./HomeFootball.vue?vue&type=template&id=f93e2a48&scoped=true&ts=true"
import script from "./HomeFootball.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeFootball.vue?vue&type=script&setup=true&lang=ts"

import "./HomeFootball.vue?vue&type=style&index=0&id=f93e2a48&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f93e2a48"],['__file',"src/components/home/HomeFootball.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f93e2a48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f93e2a48', __exports__)) {
    console.log('reload')
    api.reload('f93e2a48', __exports__)
  }
  
  module.hot.accept("./HomeFootball.vue?vue&type=template&id=f93e2a48&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('f93e2a48', render)
  })

}


export default __exports__